/**
 * Optional service price: null/undefined/0 means "price on request" (no fixed amount).
 * Services never display as $0.00.
 */

export function hasListedServicePrice(price: number | null | undefined): boolean {
  return typeof price === 'number' && !Number.isNaN(price) && price > 0;
}

export function normalizeStoredServicePrice(raw: unknown): number | null {
  if (raw === null || raw === undefined || raw === '') {
    return null;
  }
  if (typeof raw === 'number') {
    return hasListedServicePrice(raw) ? raw : null;
  }
  const n = parseFloat(String(raw).trim());
  return hasListedServicePrice(n) ? n : null;
}

/** Sum/charge helpers: missing or zero price contributes 0 to numeric totals. */
export function servicePriceForTotal(price: number | null | undefined): number {
  return hasListedServicePrice(price) ? price : 0;
}

export function formatServicePriceShort(price: number | null | undefined): string {
  if (!hasListedServicePrice(price)) {
    return 'Price on request';
  }
  return `$${price.toFixed(2)}`;
}
